import React from 'react';
import Navbar from "../components/Navbar";
import About from "../components/About";
import Footer from "../components/Footer";
import Values from '../components/Values';

function AboutPage() {
    return (
    <main>
        <Navbar/>
        <About/>
        <Values/>
        <Footer/>
    </main>
    

    )
}

export default AboutPage;